import React, { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import axios from "axios";
import { useSelector } from "react-redux";
import LottiePlayer from "lottie-react";
import noDataFound from "../Assets/animationIcons/noDataFound.json";
import logo from "../Assets/images/M.png";
import { AllUserIcon, SearchesCIcon } from "../Assets/iconshere";
import DynamicContentModal from "./DynamicContentModal";
import Skeleton from "react-loading-skeleton";
import apiClient from "../apiClient";


const initialPopup = { active: false, uuid: null };

const Environments = () => {
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const tagsData = useSelector((state) => state.applicationSlice);
  // const PlatformId = tagsData?.tags?.data?.children?.filter((e) => e.name === "Platform")[0].id;
  const [showDynamicContent, setShowDynamicContent] = useState(initialPopup);
  const [search, setSearch] = useState("");
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const getEnvironmentsList = async () => {
    try {
      setLoading(true);

      const data = await apiClient.get(`${configData.config.API_URL}/api/resource/environment/list`, {
        params: {
          applicationId: configData.config.applicationId
        }
      });

      // let { data } = await axios.get(`${configData.config.API_URL}/api/resource/environment/list`, {
      //   params: {
      //     applicationId: configData.config.applicationId
      //   },
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //     "Content-Type": "application/json",
      //   },
      // });


      setLoading(false);
      setList(data);
    } catch (error) {
      console.log(error);
    }
  };

  const openDynamicContentModal = (uuid) => {
    if (userData.user.permissions.includes("METAVERSE.DYNAMIC.CONTENT")) {
      setShowDynamicContent({ active: true, uuid: uuid });
    }
  };

  useEffect(() => {
    getEnvironmentsList();
  }, []);

  const loadBox = 4;
  const tileCards = [];

  for (let i = 0; i < loadBox; i++) {
    tileCards.push(
      <div key={`tile-${i}`} className="tilecard">
        <div className="modulecard module forload" style={{ paddingBottom: "20px !important" }}>
          <div className="cursor-pointer">
            <div className="moduleleft d-block">
              <div className="moduleicon">
                <Skeleton width="100%" height="20vh" />
              </div>
              <div className="moduledata ps-0">
                <Skeleton width="100%" height="3vh" baseColor="#ffffff" highlightColor="#ca373c50" className="my-1" />

                <Skeleton width="100%" height="7vh" className="my-1" />

                <Skeleton width="100%" height="3vh" className="my-1" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="container-fluid bg-grey-main dashboard p-3 pt-2">
        <div className="container-fluid mt-3">
          <div className="">
            <form className=" app-search app-search1">
              <div className="position-relative">
                <SearchesCIcon />
                <input
                  type="text"
                  value={search}
                  name="searchName"
                  className="form-control"
                  placeholder="Search"
                  autoComplete="off"
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </form>
          </div>
          {loading ? (
            <div className="lowersection ">
              <div className="modulelist for-env">
                <div className="course-tiles">{tileCards}</div>
              </div>
            </div>
          ) : (
            <>
              {list.length > 0 ? (
                <div className="lowersection ">
                  <div className="modulelist for-env">
                    <div className="course-tiles">
                      {list.map((item, index) => {
                        if (search && !item.name.toLowerCase().includes(search.toLowerCase())) return null;
                        return (
                          <div className="tilecard env" key={item.uuid}>
                            <div className="modulecard module" style={{ cursor: "pointer" }}>
                              <div className="cursor-pointer">
                                <div className="moduleleft d-block">
                                  <div className="moduleicon">
                                    <img
                                      src={item.versions[0].data.thumbnail || logo}
                                      className="defaultimg"
                                      alt="Default Thumbnail"
                                      referrerPolicy={"no-referrer"}
                                    />
                                  </div>
                                  <div className="moduledata">
                                    <div
                                      className="detailtags userlistnumber pb-0"
                                      style={{ justifyContent: "center" }}
                                    >
                                      <span className="me-1">
                                        {" "}
                                        <AllUserIcon />{" "}
                                      </span>
                                      <span> {item.versions[0].data.maxUsers} Users allowed </span>
                                    </div>
                                    <Tooltip key={index} title={item.name} placement="top" arrow>
                                      <p className="modulename">{item.name}</p>
                                    </Tooltip>

                                    <p className="moduledes"> {item.versions[0].data.description} </p>

                                    <div className="moduleright"></div>
                                    <div class="col-12 text-center mt-2 allcardbtns">
                                      <button class="startmodule" onClick={() => openDynamicContentModal(item.uuid)}>
                                        Dynamic Content
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-center mt-5">
                  <LottiePlayer animationData={noDataFound} style={{ height: 200 }} autoplay loop />
                  <h5>No Environments Found</h5>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <DynamicContentModal
        uuid={showDynamicContent.uuid}
        show={showDynamicContent.active}
        handleClose={() => setShowDynamicContent(initialPopup)}
      />
    </>
  );
};

export default Environments;
